<!--
 * @Author: your name
 * @Date: 2021-04-13 16:45:25
 * @LastEditTime: 2021-06-01 16:32:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\components\EcBreadcrumb\src\index.vue
-->
<template>
  <el-breadcrumb class="ec-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="item in levelList" :key="item.path">
        <span class="no-redirect">{{ item.meta.title }}</span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'EcBreadcrumb',
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if (route.path.startsWith('/redirect/')) {
      //   return
      // }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      console.log('matched:', this.$route.matched)
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/theme/variables.scss';
.ec-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 12px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #FFFFFF;
    cursor: text;
  }
  .el-breadcrumb__item:last-child .no-redirect {
    color: $--color-primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EcBreadcrumb/src/index.vue